import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { FavouriteStation } from '../../types';

export const addFavouriteStations = createReduxAsyncThunk<
  { favouriteStations: FavouriteStation[] },
  FavouriteStation['stationCode'][]
>(
  `${STATIONS_STATE}/addFavouriteStation`,
  async (stationCodes) => {
    const { data } = await stationsAPI.addFavouriteStations(stationCodes);
    return data;
  }
);
